import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $LegalRegion } from 'shared/atoms';
import { Region } from '@lemon8/web-app-shared/i18n';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

const titleMap = {
  [Region.jp]: '知的財産権について',
  [Region.gb]: 'Intellectual Property Policy',
  [Region.us]: 'Intellectual Property Policy',
  [Region.au]: 'Intellectual Property Policy',
  [Region.nz]: 'Intellectual Property Policy',
  [Region.ca]: 'Intellectual Property Policy',
  [Region.sg]: 'Intellectual Property Policy',
  [Region.th]: 'นโยบายทรัพย์สินทางปัญญา',
  [Region.id]: 'Kebijakan Kekayaan Intelektual',
  [Region.ph]: 'Intellectual Property Policy',
  [Region.my]: 'Intellectual Property Policy',
  [Region.vn]: 'Chính Sách Sở Hữu Trí Tuệ',
};

export const PolicyHead: FC = () => {
  const { region } = useAtomValue($LegalRegion);

  return (
    <DynamicHead>
      <title>{titleMap[region]}</title>
    </DynamicHead>
  );
};
